function homepageAnimation() {
    homepageMenuInner.forEach((row, index) => {
        let amountScrolled = window.pageYOffset;
        const scrollSpeed = parseInt(row.dataset.speed) / 10;
        index++;
        if (index % 2 === 0) {
            gsap.to(row, {
                x: -amountScrolled * scrollSpeed,
                ease:Linear.easeNone
            })
          } else {
            gsap.to(row, {
                x: amountScrolled * scrollSpeed,
                ease:Linear.easeNone
            })
          }
    })
}